import React from 'react'
import { strings } from '../../../localization/strings'
import { TextField } from '@material-ui/core/index'
import { platforms } from '../../../server/shared'
import { numberRegExp } from '../../../utils/regex'
import SelectSimple from '../../components/selectSimple'
import { PhoneNumberFormat } from '../../../utils/formaters'

class Component extends React.Component {
    state = {
        error: {},
    }

    componentDidMount() {}

    render() {
        const { platformId, errors, shopTypeList, validateNewShopName } =
            this.props
        const {
            token,
            name,
            mail,
            password,
            passwordConfirm,
            phoneNumber,
            shopTypeId,
            shopName,
            shopNameIsValid,
        } = this.props.initialValue
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )
        const style = { field: { margin: '10px auto', width: '100%' } }

        const shopType = shopTypeList.find((x) => x.id === shopTypeId) || null

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '50px 0px',
                }}
            >
                <div style={{ margin: '20px auto 10px auto' }}>
                    {strings.registrationFormUserHeader}
                </div>

                <TextField
                    style={style.field}
                    label={formatReq(strings.contactMail)}
                    placeholder={strings.contactMailPlaceholder}
                    value={mail}
                    onChange={(x) =>
                        this.props.onChange({ mail: x.target.value })
                    }
                    error={errors.mail}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />

                {platformId !== platforms.shopify ? (
                    <div>
                        <TextField
                            type={'password'}
                            style={style.field}
                            label={formatReq(strings.registrationPassword)}
                            value={password}
                            onChange={(x) =>
                                this.props.onChange({
                                    password: x.target.value,
                                })
                            }
                            error={errors.password}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                        <ul
                            style={{
                                color: 'red',
                                fontSize: 14,
                                display: errors.password ? 'inherit' : 'none',
                                paddingLeft: '1em',
                                fontStyle: 'italic',
                            }}
                        >
                            <li>{strings.passwordLengthHint}</li>
                            <li>{strings.passwordUpperCaseHint}</li>
                            <li>{strings.passwordLowerCaseHint}</li>
                            <li>{strings.passwordNumberHint}</li>
                        </ul>
                        <TextField
                            type={'password'}
                            style={style.field}
                            label={formatReq(
                                strings.registrationPasswordConfirmation
                            )}
                            value={passwordConfirm}
                            onChange={(x) =>
                                this.props.onChange({
                                    passwordConfirm: x.target.value,
                                })
                            }
                            error={errors.passwordConfirm}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </div>
                ) : (
                    <div />
                )}

                <div style={{ margin: '20px auto 10px auto' }}>
                    {strings.registrationFormShopHeader}
                </div>

                <TextField
                    style={{
                        ...style.field,
                        display: !token ? undefined : 'none',
                    }}
                    label={formatReq(strings.shopName)}
                    placeholder={strings.shopNamePlaceholder}
                    value={shopName}
                    onChange={(x) =>
                        this.props.onChange({ shopName: x.target.value })
                    }
                    error={errors.shopName || !shopNameIsValid}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    onBlur={() => {
                        if (shopName.length) {
                            validateNewShopName(shopName.trim())
                                .then((x) =>
                                    this.props.onChange({
                                        shopName: shopName.trim(),
                                        shopNameIsValid: x,
                                    })
                                )
                                .catch(() =>
                                    this.props.onChange({
                                        shopName: shopName.trim(),
                                        shopNameIsValid: true,
                                    })
                                )
                        }
                    }}
                    helperText={
                        shopName.length && !shopNameIsValid
                            ? strings.shopNameNotValid
                            : ''
                    }
                />

                <SelectSimple
                    label={formatReq(strings.shopType)}
                    options={shopTypeList}
                    selectedOption={shopType}
                    handleChange={(x) =>
                        this.props.onChange({ shopTypeId: x.id })
                    }
                    valueTag={'id'}
                    labelTag={'name'}
                    style={style.field}
                    error={errors.shopTypeId}
                />

                <TextField
                    style={style.field}
                    label={formatReq(strings.contactName)}
                    placeholder={strings.contactNamePlaceholder}
                    value={name}
                    onChange={(x) =>
                        this.props.onChange({ name: x.target.value })
                    }
                    error={errors.name}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />

                <TextField
                    style={style.field}
                    label={formatReq(strings.contactPhoneNumber)}
                    InputProps={{
                        inputComponent: PhoneNumberFormat,
                    }}
                    placeholder={strings.contactPhoneNumberPlaceholder}
                    value={phoneNumber}
                    onChange={(x) =>
                        !!x.target.value && !numberRegExp.test(x.target.value)
                            ? 0
                            : this.props.onChange({
                                  phoneNumber: x.target.value,
                              })
                    }
                    error={errors.phoneNumber}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />
                <ul
                    style={{
                        color: 'red',
                        fontSize: 14,
                        display: errors.phoneNumber ? 'inherit' : 'none',
                        paddingLeft: '1em',
                        fontStyle: 'italic',
                    }}
                >
                    <li>{strings.phoneNumberHint}</li>
                </ul>
            </div>
        )
    }
}

export default Component
